import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformAccordionItemComponent = (props: CMSTransformerDataType) => {
  const accordionComponentTransformedProps = Array.isArray(props?.accordion_component)
    ? props?.accordion_component[0]
    : props?.accordion_component;
  const { items: accordionItemArr, section_title } = accordionComponentTransformedProps;
  return {
    componentType: ComponentType.accordion_component,
    accordionItemArr,
    sectionTitle: section_title,
  };
};
export default transformAccordionItemComponent;
